import ScheduleReports from "@/services/api/scheduleReport";
import { handleResponse } from "@/services/axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface Report {
    scheduleReport: any[];
    loading: {
        scheduleReport: { [key: number]: boolean };
        scheduleList: boolean;
    };
    error: string | null;
}

const initialState: Report = {
    scheduleReport: [],
    loading: {
        scheduleReport: {},
        scheduleList: false,
    },
    error: null,
}

export const addScheduleReports = createAsyncThunk(
    "report/addScheduleReports",
    async ({ id, data }: any, { rejectWithValue }) => {
        try {
            const response = await ScheduleReports.addScheduleReports(id, data);
            return handleResponse(response, rejectWithValue);
        } catch (err: any) {
            return rejectWithValue(

                err?.response.data.message || "Failed"
            );
        }
    },
);

export const getScheduleReports = createAsyncThunk(
    "report/getScheduleReports",
    async (_, { rejectWithValue }) => {
        try {
            const response = await ScheduleReports.getScheduleReports();
            return handleResponse(response, rejectWithValue);
        } catch (err: any) {
            return rejectWithValue(
                err?.response.data.message || "Failed"
            );
        }
    }
);

const scheduleReportsSlice = createSlice({
    name: "scheduleReports",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getScheduleReports.pending, (state) => {
                state.error = null;
                state.loading.scheduleList = true;
                state.scheduleReport = [];
            })
            .addCase(getScheduleReports.fulfilled, (state, action) => {
                state.error = null;
                state.loading.scheduleList = false;
                state.scheduleReport = action.payload || [];
            })
            .addCase(getScheduleReports.rejected, (state, action) => {
                state.error = action.payload as string;
                state.loading.scheduleList = false;
                state.scheduleReport = [];
            })

            .addCase(addScheduleReports.pending, (state, action) => {
                const id = action.meta.arg.id;
                state.loading.scheduleReport[id] = true;
            })

            .addCase(addScheduleReports.fulfilled, (state, action) => {
                const id = action.meta.arg.id;
                state.loading.scheduleReport[id] = false;
            })

            .addCase(addScheduleReports.rejected, (state, action) => {
                const id = action.meta.arg.id;
                state.loading.scheduleReport[id] = false;
            });
    },
});

export default scheduleReportsSlice.reducer;